import api from "../api/facilities";
import {logSuccess, logError, createError} from "../../ui/Notify";
import types from "./types";

function requestFacilities() {
  return {
    type: types.GET_FACILITIES_REQUEST,
    isFetchingList: true
  };
}

function requestFacilitiesCompleted(facilities) {
  return {
    type: types.GET_FACILITIES_COMPLETED,
    isFetchingList: false,
    facilities
  };
}

function requestFacilitiesError(facilitiesError) {
  return {
    type: types.GET_FACILITIES_ERROR,
    isFetchingList: false,
    facilitiesError
  };
}

function requestFacility() {
  return {
    type: types.GET_FACILITY_REQUEST,
    isFetchingFacility: true
  };
}

function requestFacilityCompleted(facilityCard) {
  return {
    type: types.GET_FACILITY_COMPLETED,
    isFetchingFacility: false,
    facilityCard
  };
}

function requestFacilityError(facilityCardError) {
  return {
    type: types.GET_FACILITY_ERROR,
    isFetchingFacility: false,
    facilityCardError
  };
}

function requestFullFacility() {
  return {
    type: types.GET_FULL_FACILITY_REQUEST,
    isFetchingFullFacility: true
  };
}

function requestFullFacilityCompleted(facilityFullInfo) {
  return {
    type: types.GET_FULL_FACILITY_COMPLETED,
    isFetchingFullFacility: false,
    facilityFullInfo
  };
}

function requestFullFacilityError(facilityFullError) {
  return {
    type: types.GET_FULL_FACILITY_ERROR,
    isFetchingFullFacility: false,
    facilityFullError
  };
}

function createFacilityRequest() {
  return {
    type: types.CREATE_FACILITY_REQUEST,
    isCreatingFacility: true
  };
}

function createFacilityCompleted(createdFacility) {
  return {
    type: types.CREATE_FACILITY_COMPLETED,
    isCreatingFacility: false,
    createdFacility
  };
}

function createFacilityError(facilityCreationError) {
  return {
    type: types.CREATE_FACILITY_ERROR,
    isCreatingFacility: false,
    facilityCreationError
  };
}

function updateFacilityRequest() {
  return {
    type: types.UPDATE_FACILITY_REQUEST,
    isUpdatingFacility: true
  };
}

function updateFacilityCompleted(updatedFacility) {
  return {
    type: types.UPDATE_FACILITY_COMPLETED,
    isUpdatingFacility: false,
    updatedFacility
  };
}

function updateFacilityError(facilityUpdateError) {
  return {
    type: types.UPDATE_FACILITY_ERROR,
    isUpdatingFacility: false,
    facilityUpdateError
  };
}

function requestOrganizations() {
  return {
    type: types.GET_ORGANIZATIONS_REQUEST,
    isFetchingOrganizations: true
  };
}

function requestOrganizationsCompleted(organizations) {
  return {
    type: types.GET_ORGANIZATIONS_COMPLETED,
    isFetchingOrganizations: false,
    organizations
  };
}

function requestOrganizationsError(organizationsError) {
  return {
    type: types.GET_ORGANIZATIONS_ERROR,
    isFetchingOrganizations: false,
    organizationsError
  };
}

function requestMunicipals() {
  return {
    type: types.GET_MUNICIPALS_REQUEST,
    isFetchingMunicipals: true
  };
}

function requestMunicipalsCompleted(municipals) {
  return {
    type: types.GET_MUNICIPALS_COMPLETED,
    isFetchingMunicipals: false,
    municipals
  };
}

function requestMunicipalsError(municipalsError) {
  return {
    type: types.GET_MUNICIPALS_ERROR,
    isFetchingMunicipals: false,
    municipalsError
  };
}

function requestDepartments() {
  return {
    type: types.GET_DEPARTMENTS_REQUEST,
    isFetchingDepartments: true
  };
}

function requestDepartmentsCompleted(departments) {
  return {
    type: types.GET_DEPARTMENTS_COMPLETED,
    isFetchingDepartments: false,
    departments
  };
}

function requestDepartmentsError(departmentsError) {
  return {
    type: types.GET_DEPARTMENTS_ERROR,
    isFetchingDepartments: false,
    departmentsError
  };
}

function editDepartmentsRequest() {
  return {
    type: types.EDIT_DEPARTMENTS_REQUEST,
    isEditingDepartments: true
  };
}

function editDepartmentsCompleted(departmentsEdited) {
  return {
    type: types.EDIT_DEPARTMENTS_COMPLETED,
    isEditingDepartments: false,
    departmentsEdited
  };
}

function editDepartmentsError(departmentsEditError) {
  return {
    type: types.EDIT_DEPARTMENTS_ERROR,
    isEditingDepartments: false,
    departmentsEditError
  };
}

function addImagesCompleted(images) {
  return {
    type: types.ADD_IMAGES_COMPLETED,
    images
  };
}

function addImagesError(imagesError) {
  return {
    type: types.ADD_IMAGES_ERROR,
    imagesError
  };
}

export function getFacilities() {
  return dispatch => {
    dispatch(requestFacilities());
    return api
      .getFacilitiesList()
      .then(response => {
        if (response.status === 200) {
          //console.log(response);
          dispatch(requestFacilitiesCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(requestFacilitiesError(err.response));
        } else {
          logError(err);
          dispatch(requestFacilitiesError(createError("Не уадлсоь загрузить список адресов")));
        }
      });
  };
}

export function getFacility(id) {
  return dispatch => {
    dispatch(requestFacility());
    return api
      .getFacilityCard(id)
      .then(response => {
        if (response.status === 200) {
          console.log(response);
          dispatch(requestFacilityCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(requestFacilityError(err.response));
        } else {
          logError(err);
          dispatch(requestFacilityError(createError("Не удалось получить данные адреса")));
        }
      });
  };
}

export function getFullFacility(id) {
  return dispatch => {
    dispatch(requestFullFacility());
    return api
      .getFacilityFullInfo(id)
      .then(response => {
        if (response.status === 200) {
          let facility = response.data;
          facility = {
            ...facility,
            data: {
              ...facility.data,
              region: facility.info.regionId
            }
          };

          dispatch(requestFullFacilityCompleted(facility));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(requestFullFacilityError(err.response));
        } else {
          logError(err);
          dispatch(requestFullFacilityError(createError("Не удалось загрузить данные адреса")));
        }
      });
  };
}

export function createFacility(data) {
  return dispatch => {
    dispatch(createFacilityRequest());
    return api
      .createFacility(data)
      .then(response => {
        if (response.status === 200) {
          //console.log(response);
          dispatch(createFacilityCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(createFacilityError(err.response));
        } else {
          logError(err);
          dispatch(createFacilityError(createError("Не удалось отправить запрос создания адреса")));
        }
      });
  };
}

export function updateFacility(id, data) {
  return (dispatch, getState) => {
    dispatch(updateFacilityRequest());
    return api
      .updateFacility(id, data)
      .then(response => {
        if (response.status === 200) {
          logSuccess("Успешно обновлено");
          dispatch(updateFacilityCompleted(response.data));
          dispatch(getFacility(getState().facilities.facilityCard.id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(updateFacilityError(err.response));
        } else {
          logError(err);
          dispatch(updateFacilityError(createError("Не удалось отправиь запрос на обновление адреса")));
        }
      });
  };
}

export function getOrganizations() {
  return dispatch => {
    dispatch(requestOrganizations());
    return api
      .getOrganizationsList()
      .then(response => {
        if (response.status === 200) {
          console.log(response);
          dispatch(requestOrganizationsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(requestOrganizationsError(err.response));
        } else {
          logError(err);
          dispatch(requestOrganizationsError(createError("Не удалось получить список организаций")));
        }
      });
  };
}

export function getMunicipals(region) {
  return dispatch => {
    dispatch(requestMunicipals());
    return api
      .getMunicipalsList(region)
      .then(response => {
        if (response.status === 200) {
          console.log(response);
          dispatch(requestMunicipalsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(requestMunicipalsError(err.response));
        } else {
          logError(err);
          dispatch(requestMunicipalsError(createError("Не удалось получить писок муниципальных образований")));
        }
      });
  };
}

export function getDepartments(id) {
  return dispatch => {
    dispatch(requestDepartments());
    return api
      .getFacilityDepartments(id)
      .then(response => {
        if (response.status === 200) {
          console.log(response);
          dispatch(requestDepartmentsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response &&  err.response.status === 400) {
          logError(err.response);
          dispatch(requestDepartmentsError(err.response));
        } else {
          logError(err);
          dispatch(requestDepartmentsError(createError("Не удалсоь получить список подразделений")));
        }
      });
  };
}

export function editDepartments(facilityId, deps) {
  return async dispatch => {
    dispatch(editDepartmentsRequest());
    const checked = deps.filter(({ checked }) => checked);
    const unchecked = deps.filter(({ checked }) => !checked);

    const response = await Promise.allSettled(
      [...checked.map(({ id }) => api.addFacilityDepartment(facilityId, id))],
      [
        ...unchecked.map(({ id }) =>
          api.deleteFacilityDepartment(facilityId, id)
        )
      ]
    );

    if (response.every(res => res.value.status === 200)) {
      dispatch(editDepartmentsCompleted(response));
    } else {
      dispatch(editDepartmentsError(response));
    }
    return response;
  };
}

export function addImages(images) {
  return async (dispatch, getState) => {
    const id = getState().facilities.facilityFullInfo.info.id;
    const response = await Promise.all(
      images.map(image => api.addFacilityImage(id, image))
    );

    if (response.every(({ data }) => data.success === true)) {
      dispatch(addImagesCompleted(response));
      dispatch(getFacility(id));
    } else {
      dispatch(addImagesError(response));
    }
    return response;
  };
}

export default {
  getFacilities,
  getFacility,
  getFullFacility,
  createFacility,
  updateFacility,
  getOrganizations,
  getMunicipals,
  getDepartments,
  editDepartments,
  addImages,
};
